import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { LOCATIONS, LOCATION_ADD, LOCATION_DELETE } from "./actionTypes";
import {
  apiError,
  getLocations,
  locationListSuccessful,
  locationAddSuccessful,
} from "./actions";

// AUTH related methods
import {
  postAdd,
  getList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getLocation() {
  try {
    const response = yield call(getList, "/masters/locations/", {});
    yield put(locationListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
//If user is login then dispatch redux action's are directly from here.
function* AddLocation({ payload: { location } }) {
  try {
    if (location.id === "") {
      const response = yield call(postAdd, "/masters/locations/", {
        name: location.name,
      });
      if (response.status === 201) {
        swal("Your Location Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getLocations());
      } else {
        swal("Sorry! Unable to added Location. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(locationAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/locations/" + location.id,
        {
          code: location.code,
          name: location.name,
          modifiedon: new Date(location.createdon),
        }
      );
      if (response.status === 200) {
        swal("Your Location Edited Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getLocations());
      } else {
        swal("Sorry! Unable to edit Location. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(locationAddSuccessful(null));
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });
    //yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* DeleteLocation(locId) {
  try {
    const response = yield call(
      postDelete,
      "/masters/locations/" + locId.payload.locId
    );

    if (response.status === 204) {
      swal(" Your Location has been deleted!", {
        icon: "success",
        timer: 1500,
      });
      yield put(getLocations());
    } else {
      swal("Sorry! Your Location has been not deleted!", {
        icon: "error",
      });
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}

export function* watchgetLocations() {
  yield takeEvery(LOCATIONS, getLocation);
}
export function* watchLocationAdd() {
  yield takeEvery(LOCATION_ADD, AddLocation);
}

export function* watchLocationDelete() {
  yield takeEvery(LOCATION_DELETE, DeleteLocation);
}

function* LocationSaga() {
  yield all([
    fork(watchgetLocations),
    fork(watchLocationAdd),
    fork(watchLocationDelete),
  ]);
}

export default LocationSaga;
